import { useRegisterSW } from 'virtual:pwa-register/vue';
import type { UserModule } from '~/types';
import { useModalHistory } from '~/composable/use_modal_history';

export const install: UserModule = ({ router }) => {
    const history = useModalHistory();
    let reloadPending = false;
    let checkForUpdate = () => {};

    watch(history, (entries) => {
        if (entries.length !== 0) {
            return;
        }

        if (reloadPending) {
            window.location.reload();
        } else {
            checkForUpdate();
        }
    });

    useRegisterSW({
        onNeedReload() {
            reloadPending = true;
            if (history.value.length === 0) {
                window.location.reload();
            }
        },
        onRegisteredSW(_swScriptUrl, registration) {
            if (!registration) {
                return;
            }

            checkForUpdate = () => void registration.update();

            window.addEventListener('focus', checkForUpdate);
            router.afterEach(checkForUpdate);
        },
    });
};
